import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as triangle from '../triangle.js';

export {
    init,
}

// NOTE: IDEA: Should there be a faint trace of the grudge drawn on the floor?

let whistlePanner;

const POIs = [
    {
        name: 'grudge',
        position: { x: -26, y: 11, z: 0.5 },
        color: 'violet',
        hideOnMap: true,
        sound: {
            name: 'grudge',
            gain: 0,
        },
        wander: {
            mode: 'loop',
            points: [
                { x: -26, y: 11, z: 0.5, s: 1 },
                { x: -28, y: -4, z: 0.5, s: 1 },
                { x: -19, y: -19, z: 0.5, s: 1 },
                { x: -4, y: -14, z: 0.5, s: 1 },
                { x: 7, y: -20, z: 0.5, s: 1 },
                { x: 16, y: 8, z: 0.5, s: 1 },
                { x: -9, y: 14, z: 0.5, s: 1 },
            ],
            pause(callback) {
                // FIXME: There should be a better way to get this POI main sound source reference
                //        Maybe the pause method should be on POIs root ?
                const p = scene.POIs.find(p => p.name === 'grudge');

                // Fade out the main POI sound
                p.sound.source.fade();

                // Position the whistle panner and play the sound once
                whistlePanner.positionPanner(p.position.x, p.position.z, p.position.y);
                audio.buffers.play('whistle', {
                    destination: whistlePanner,
                    gain: 0,
                });
                
                // Drop key
                triangle.drop('stonehenge-triangle-8', p.position, {
                    collisionRadius: 0.5,
                    despawn: 12,
                    offset: { x: 0.8, y: -0.8 },
                });

                setTimeout(() => {
                    p.sound.source.fadeTo(2, 0, -90);
                    callback();
                }, 12000);
            }
        },
        async onStart() {
            audio.panner.play(this);
            whistlePanner = audio.panner.createPanner();
        },
    },
];

const sounds = [
    { name: 'grudge', url: new URL('../../sound/GrudgeComplet.wav', import.meta.url) },
    { name: 'whistle', url: new URL('../../sound/GrudgeSiffle.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
